import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE, MAILING_LIST_DESC_INPUT_LABEL_TEXT, MAILING_LIST_DESC_INPUT_TEST_ID, MAILING_LIST_DESC_INPUT_HELPER_TEXT, MAILING_LIST_TITLE_INPUT_TEST_ID, MAILING_LIST_SECTION_ID, MAILING_LIST_TITLE_INPUT_LABEL_TEXT } from './constants';
import { SourceType } from '../../types';
export var MailingListCitingSection = function MailingListCitingSection(_ref) {
  var _ref$sourceType = _ref.sourceType,
    sourceType = _ref$sourceType === void 0 ? SourceType.MAILING_LIST : _ref$sourceType;
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: MAILING_LIST_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(MAILING_LIST_SECTION_ID, "-label"),
    dataTestId: MAILING_LIST_SECTION_ID
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "".concat(sourceType, ".title"),
    labelText: MAILING_LIST_TITLE_INPUT_LABEL_TEXT,
    "data-test": MAILING_LIST_TITLE_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "".concat(sourceType, ".description"),
    labelText: MAILING_LIST_DESC_INPUT_LABEL_TEXT,
    helperText: MAILING_LIST_DESC_INPUT_HELPER_TEXT,
    "data-test": MAILING_LIST_DESC_INPUT_TEST_ID
  }));
};